__turbopack_context__.v({
  "mb": "styles-module-scss-module__PMzbPG__mb",
  "modal": "styles-module-scss-module__PMzbPG__modal",
});
